import React from 'react';
import { Button, ButtonProps } from 'antd';
import './AccentButtonDark.css';

/**
 * AccentButtonDark
 * A darker variant of AccentButton for secondary actions in the sidebar.
 */
export default function AccentButtonDark({ className, ...props }: ButtonProps) {
    return (
        <Button
            {...props}
            className={`accent-button-dark ${className || ''}`}
        />
    );
}
